/**
 * 実績履歴取得VO
 */
export class ResultListModel {
  public formId: string = <string>'';         // 画面ID
  public pCode: string = <string>'';          // Ｐコード
  public page: number;                        // 取得対象ページ
  public sortItem: string = <string>'';       // ソート指定項目
  public sortOrder: string = <string>'';      // 昇順降順
  public makedWKT: boolean = <boolean>false;  // 実績履歴のWorkTable作成有無
  public totalCnt: number = <number>0;		    // 検索結果総件数
  public sessionId: string = <string>'';      // SessionID
}
